export default __webpack_public_path__ + "static/media/calendar-time.d8da5d5e.svg";